import { html } from 'htm/preact';

const NumberList = ({ items }) => {
  return html`
    <ol class="text-xs leading-tight space-y-3">
      ${items.map(
        (item, idx) => html`
          <li class="flex gap-2.5">
            <span
              class="flex items-center justify-center rounded-full w-6 h-6 bg-yellow text-purple text-xs font-bold font-serif leading-none shrink-0 -mt-1"
            >
              ${idx + 1}
            </span>
            <span>${item}</span>
          </li>
        `,
      )}
    </ol>
  `;
};

export default NumberList;
